import { apiProvider, BASE_URL } from "./core/provider";
import { config } from "../core";

const checked = (response) => {
  const data = response?.data;
  if (data?.status !== 200 || data.result == null) {
    const error = new Error(data?.errors?.[0]?.message || data?.message || "Clock request failed.");
    error.status = data?.status;
    throw error;
  }
  return data.result;
};

export const apiAttendance = {
  get: (date = "") => apiProvider.get(`attendance?date=${encodeURIComponent(date)}`).then(checked),
  getUser: (id, date = "") => apiProvider.get(`attendance/users/${encodeURIComponent(id)}?date=${encodeURIComponent(date)}`).then(checked),
  change: (data) => apiProvider.post("attendance", data).then(checked),
  heartbeat: (inputAgeSeconds) => apiProvider.post("attendance/heartbeat", { inputAgeSeconds }).then(checked),
  // Axios cannot keep a request alive across navigation; retain the same JWT/company headers.
  flushActivity: (inputAgeSeconds) => fetch(`${BASE_URL()}/attendance/heartbeat`, {
    method: "POST", keepalive: true,
    headers: { Authorization: `Bearer ${config.api.jwt}`, "X-Company-ID": config.user.company, "Content-Type": "application/json" },
    body: JSON.stringify({ inputAgeSeconds }),
  }).catch(() => {}),
};
